import React from "react";
import "./WhyChooseUs.css";
import whychooseus from "./images/whychooseus.png";

function WhyChooseUs() {
  return (
    <div className="whychooseus_outer">
      <div className="container">
        <div className="whychooseus_inner">
          <div className="whychooseus_heading">
            <div className="whychooseus_mainhead">Why Choose Us?</div>
            <div className="whychooseus_p">
              Take control of your financial future with smart personal finance management from Final Tax. Here's what sets us apart
            </div>
          </div>
          <div className="whychooseus_content">
            <div className="whychooseus_img">
              <img src={whychooseus} alt="" />
            </div>
            <div className="whychooseus_box">
              <div className="whychooseus_small">
                <ul>
                  <li>✅ 100% Data Security & Privacy <br />
                          Your financial information is safe and confidential with us.</li>
                  <li>✅ Free Live return filing <br />
                      File your returns easily and accurately, at no cost.
                  </li>
                  <li>✅ Year-Round e-CA Support <br />
                    Get expert assistance for general queries anytime throughout the year.
                  </li>
                  <li>✅ Complimentary Tax Planning Guidance <br />
                  Maximize your savings with personalized tax strategies.
                  </li>
                  <li>
                    ✅ Free Investment & Declaration Advisory <br />
                    Receive expert advice on smart investment options and company declarations.
                  </li>
                  <li>✅ WhatsApp Support <br />
                    Quick resolutions and support—just a message away
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WhyChooseUs;
